import React from "react";
import { useTranslation } from "react-i18next";

import { HamburgerIcon } from "@chakra-ui/icons";
import { Badge, Flex, Td, Text, Tr, Icon, Menu, MenuButton, MenuList, MenuItem } from "@chakra-ui/react";
import moment from "moment";


import { API } from "../../../utils/http";
import { fullDateTimeFormat } from "../../../utils/types";
function DocumentsTableRow(props) {
	const { t } = useTranslation();
	const { row, propertyId } = props;
	const getDocument = (documentId, documentName) => {
		const payload = { documentId, propertyId, documentName };
		console.log("view: ", payload);
		API.put("get-document", payload).then((r) => {
			console.log(r);
			window.open(r.data.url, "_blank");
		});
	};
	return (
		<Tr>
			<Td minWidth={{ sm: "200px" }}>
				<Flex py=".8rem" direction={"column"}>
					<Text fontSize="md">{moment(row.addedDate).format(fullDateTimeFormat)}</Text>
					{row.active && (
						<Badge width={"fit-content"} colorScheme="green">
							Active
						</Badge>
					)}
				</Flex>
			</Td>
			<Td>
				<Text fontSize="md" pb=".5rem">
					{row.name}
				</Text>
			</Td>
			<Td>
				<Text fontSize="md" pb=".5rem">
					{t(`types.${row.type}`) || "-"}
				</Text>
			</Td>
			<Td>
				<Text fontSize="md" pb=".5rem">
					{row.number}
				</Text>
			</Td>
			<Td>
				<Text fontSize="md" pb=".5rem">
					{row.startingDate || "-"}
				</Text>
			</Td>
			<Td>
				<Text fontSize="md" pb=".5rem">
					{row.expirationDate}
				</Text>
			</Td>
			<Td>
				<Menu closeOnSelect={false}>
					<MenuButton>
						<Icon as={HamburgerIcon} />
					</MenuButton>
					<MenuList>
						<MenuItem
							onClick={() => {
								getDocument(row.id, row.name);
							}}
						>
							Download
						</MenuItem>
					</MenuList>
				</Menu>
				{/* <Stack direction="row">
					<Button
						onClick={() => {
							getDocument(row.id);
						}}
					>
						<Tooltip label="Download">
							<Icon as={DownloadIcon} color={"teal.400"} boxSize={6}></Icon>
						</Tooltip>
					</Button>
					<Button
						colorScheme={"red"}
						onClick={() => {
							deleteDocument(row.id);
						}}
					>
						<Tooltip label="Download">
							<Icon as={DeleteIcon} boxSize={6}></Icon>
						</Tooltip>
					</Button>
				</Stack> */}
			</Td>
		</Tr>
	);
}

export default DocumentsTableRow;
